module.exports = __webpack_public_path__ + "static/media/repproved.4fd2f711.svg";